import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Sales.ContractRefundDealerPaymentControl.Save.IRequest;
type Response = Api.Sales.ContractRefundDealerPaymentControl.Save.IResponse;
type Headers = Api.Sales.ContractRefundDealerPaymentControl.Save.IHeaders;
const url = '/api/Sales/ContractRefundDealerPaymentControl';
export default async function contractRefundDealerPaymentControlSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
